import { call, put } from 'redux-saga/effects';
import ActionTypes from '../actionTypes';

export function* getAllOriginals(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_ALL_ORIGINALS', 'GET', {
      routeParams: {},
      query: {
        page: action?.page ?? 0,
      },
    }));

    yield put({
      type: ActionTypes.originals.getAll.SUCCESS,
      page: action?.page,
      response,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    yield put({
      type: ActionTypes.originals.getAll.ERROR,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error getting the ZIYNX Originals.',
      },
    });
  }
}

export function* postOriginal(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('POST_ORIGINAL', 'POST', {
      body: action?.body ?? {},
    }));
    yield put({
      type: ActionTypes.originals.post.SUCCESS,
      response,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'success',
        content: 'Successfully created the ZIYNX Original!',
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    yield put({
      type: ActionTypes.originals.post.ERROR,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error creating the ZIYNX Original.',
      },
    });
  }
}

export function* getOriginal(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_ONE_ORIGINAL', 'GET', {
      routeParams: {
        id: action?.id,
      },
    }));
    yield put({
      type: ActionTypes.originals.get.SUCCESS,
      id: action?.id,
      response,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    yield put({
      type: ActionTypes.originals.get.ERROR,
      id: action?.id,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error getting the ZIYNX Original.',
      },
    });
  }
}

export function* patchOriginal(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_ORIGINAL', 'PATCH', {
      routeParams: {
        id: action?.id,
      },
      body: action?.body ?? [],
    }));
    yield put({
      type: ActionTypes.originals.patch.SUCCESS,
      id: action?.id,
      response,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'success',
        content: 'Successfully updated the ZIYNX Original!',
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    yield put({
      type: ActionTypes.originals.patch.ERROR,
      id: action?.id,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error updating the ZIYNX Original.',
      },
    });
  }
}

export function* deleteOriginal(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('DELETE_ORIGINAL', 'DELETE', {
      routeParams: {
        id: action?.id,
      },
    }));
    yield put({
      type: ActionTypes.originals.delete.SUCCESS,
      id: action?.id,
      response,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'success',
        content: 'Successfully deleted the ZIYNX Original!',
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    yield put({
      type: ActionTypes.originals.delete.ERROR,
      id: action?.id,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error deleting the ZIYNX Original.',
      },
    });
  }
}
